import axios from 'axios'
import '../Config'

const INSTRUCTOR = 'v1'
const COURSE_API_URL = global.config.backend
const INSTRUCTOR_API_URL = `${COURSE_API_URL}/${INSTRUCTOR}`

class AutenticacaoService {

    autenticar(creadenciais) {
        return axios.post(`${INSTRUCTOR_API_URL}/signIn`, creadenciais);
    }
}

export default new AutenticacaoService()